export default {
  id: 'ClassBillingMethod',
  code: 'CN',
  text: {
    'By hours': '每课时',
    'By lessons': '每课节',
    'By terms': '每课期',
    '': '课程按课期总价收费 并且按课时计算消耗',
    'None': '无单价',
    'Lesson rate': '课程单价',
    'Hour rate': '课时单价',
    'Classes are charged at the price of each term and are calculated for consumption according to class hours used.': '班级将按课期总价收费，并且按上课时计算消耗。',
    'Classes are charged at the price of each term and are calculated for consumption according to lessons used.': '班级将按课期总价收费，并且按已上课节计算消耗。',
    'Classes are charged at the price of each term and are calculated for consumption after the fee is paid.': '班级将按课期总价收费，并且在缴费时计算消耗。',
    'Classes are charged at the price of each class hours and are calculated for consumption according to class hours used.': '班级将按课时单价收费，并且按已上课时计算消耗。',
    'Classes are charged at the price of each lessons and are calculated for consumption according to lessons used.': '班级将按课节单价收费，并且按已上课节计算消耗。',
    '': '',
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/ClassBillingMethod/locale.js